import { Controller } from "@hotwired/stimulus"

// Remembers whether the desktop sidebar is collapsed (the #nav-toggle
// checkbox) in a cookie, which the layouts read to render it the same way on
// the next page. See ApplicationHelper#sidebar_collapsed?.
export default class extends Controller {
  remember() {
    const value = this.element.checked ? "1" : "0"
    document.cookie = `sidebar_collapsed=${value}; path=/; max-age=31536000; SameSite=Lax`
  }
}
